module.exports = __webpack_public_path__ + "media/images/pic/advantage-ca33ef420ed378f576983785f8477ce8.png";